import Vue from "vue"
import Vuex from "vuex"
import * as accountModule from "@/store/account.module"
import * as productsModule from "@/store/products.module"
import * as storesModule from "@/store/stores.module"
import * as authModule from "@/store/auth.module"
import {AccountState} from "@/store/account.module"
import {ProductsState} from "@/store/products.module"
import {StoreState} from "@/store/stores.module"
import {AuthState} from "@/store/auth.module"
import logger from "@/utils/logging"
import {ApiError} from "@/services/ApiError"
import Tracker from "@/services/tracking.service"

Vue.use(Vuex)

export interface AppState {
    account: AccountState,
    products: ProductsState,
    stores: StoreState,
    auth: AuthState
}

export const Namespaces = {
    ACCOUNT: accountModule.namespace,
    PRODUCTS: productsModule.namespace,
    STORES: storesModule.namespace,
    AUTH: authModule.namespace,
}

const vueStore = new Vuex.Store<AppState>({
    strict: process.env.NODE_ENV !== "production",
    plugins: [Tracker.plugin],
    modules: {
        [Namespaces.ACCOUNT]: accountModule.module,
        [Namespaces.PRODUCTS]: productsModule.module,
        [Namespaces.STORES]: storesModule.module,
        [Namespaces.AUTH]: authModule.module,
    },
})
export default vueStore

export const store = {
    getters: {
        account: accountModule.wrapGetters(vueStore),
        stores: storesModule.wrapGetters(vueStore),
        products: productsModule.wrapGetters(vueStore),
        auth: authModule.wrapGetters(vueStore),
    },
    actions: {
        account: accountModule.wrapActions(vueStore),
        stores: storesModule.wrapActions(vueStore),
        products: productsModule.wrapActions(vueStore),
        auth: authModule.wrapActions(vueStore),
    },
    state: vueStore.state as AppState,
}

export class RemoteDataError {
    public readonly code: string
    public readonly message: string

    constructor(e: Error) {
        this.code = e instanceof ApiError ? e.errorCode : "unknown"
        this.message = e.message
    }
}

export interface RemoteData<T> {
    isLoading: boolean
    error: RemoteDataError | null,
    data?: T
}
